<script lang="ts">
    import Button from "@/lib/components/ui/button/button.svelte";

    export let onAcknowledge: () => void
</script>

<div
    class="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-sm shadow-lg"
    role="region"
    aria-label="Cookie notice"
>
    <div class="max-w-4xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div class="flex-1 text-sm text-muted-foreground leading-relaxed">
            <p>
                <span class="font-medium text-foreground">We use cookies</span>
                to keep you signed in and to protect sign-up from abuse with Google
                reCAPTCHA. Both are strictly necessary to run this page — no
                advertising or analytics cookies are set here.
                See our <a href="/legal/privacy" target="_blank" rel="noopener" class="underline text-xerteal-600 hover:text-xerteal-700">Privacy Policy</a>.
            </p>
        </div>
        <div class="shrink-0">
            <Button size="sm" on:click={onAcknowledge}>
                Got it
            </Button>
        </div>
    </div>
</div>
